/**
 * The Solventum green identity, expressed as the experience's material palette.
 * Every clinical need takes a different position in the green spectrum so the
 * family stays colour-coded without leaving the brand.
 */
export const brand = {
  /** Pale enamel green — translucency, aesthetics */
  mint: '#A8EFA0',
  /** Signature Solventum green */
  green: '#7BDF8B',
  /** Fresh lime green — everyday, versatility */
  lime: '#9FD14A',
  /** Emerald — depth, posterior efficiency */
  emerald: '#2FC08A',
  /** Aqua green — flow and adaptation */
  aqua: '#58DAC6',
  /** Deep green-black surface */
  ink: '#071A14',
  /** Muted green-grey for secondary type */
  dim: '#8CA79B',
  /** Resting state for interactive type */
  quiet: '#BFD3C7'
}
